import { render, staticRenderFns } from "./DelegateOrder.vue?vue&type=template&id=e7464d72"
import script from "./DelegateOrder.vue?vue&type=script&lang=js"
export * from "./DelegateOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports